// extracted by mini-css-extract-plugin
export default {"title":"OezldXxrRszaBCJ4EOfT","root":"zK4JB8cQMvl39BmBrwZk"};